(() => {
  const breadcrumb_wrapper = $('#bredcrumbWrapId .breadcrumbs');
  const left_gradient = $('#bredcrumbWrapId .mobile-gradient.left');
  const right_gradient = $('#bredcrumbWrapId .mobile-gradient.right');
  
  //Control when gradients should be displayed
  breadcrumb_wrapper.on("scroll", function() {
    const scroll_position = breadcrumb_wrapper.scrollLeft();
    if( scroll_position > 1){
      left_gradient.add(right_gradient).addClass('active');
    }else {
      left_gradient.add(right_gradient).removeClass('active');
    }
  });
})();